import React from "react";
import { Outlet } from "react-router-dom";
import logo from "../../assets/AuthPics/toplogo.png";
import sidepic from "../../assets/HomePics/Homepic1.jpg";

const AuthLayout = () => {
  return (
    <div className="flex h-screen w-screen bg-gray-100 items-center justify-center relative">
      
      {/* Logo positioned at the top-left */}
      <img
        src={logo}
        alt="AI AURA Logo"
        className="absolute top-6 left-6 w-32 h-auto"
      />

      <div className="flex flex-col md:flex-row bg-white rounded-none shadow-none overflow-hidden w-full h-full">
        
        {/* LEFT COLUMN: Auth Form Area */}
        <div className="w-full md:w-1/2 p-8 flex flex-col justify-center bg-white">
          {/* Render dynamic auth components here via Outlet */}
          <Outlet />
        </div>

        {/* RIGHT COLUMN: Marketing/Branding */}
        <div className="hidden md:flex md:w-1/2 bg-[#102742] pl-8 flex-col rounded-xl justify-center text-white h-full">
          <img
            src={sidepic}
            alt="AI Illustration"
            className="h-auto mb-6"
          />
          <h2 className="text-4xl font-bold mb-4 text-center">
            Smarter Hiring, Faster Growth.
          </h2>
          <p className="text-center leading-relaxed">
            Find, Track, and Hire Top Talent with AI-Powered Recruitment Software.
            Save time, reduce hiring costs, and build your dream team with an all-in-one hiring platform.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
